import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";

/**
 * Normalize input to a Blob.
 * Accepts:
 *  - Blob/File directly (returned as-is)
 *  - http(s) URL or data URL (fetched to Blob)
 */
const ensureBlob = async (input) => {
  if (input instanceof Blob || input instanceof File) return input;
  if (typeof input === "string") {
    const response = await fetch(input);
    return await response.blob();
  }
  throw new Error("Expected a Blob/File or URL string");
};

/**
 * Upload circular PNG avatar to Firebase Storage and return a download URL.
 * Accepts Blob/File OR a URL/dataURL. Saves as PNG to preserve transparency.
 */
export const uploadProfileImageToFirebase = async (fileOrUrl, userId) => {
  if (!userId) throw new Error("uploadProfileImageToFirebase: missing userId");

  // 1) Normalize to Blob
  const blob = await ensureBlob(fileOrUrl);

  // 2) Upload as PNG (keep transparency)
  const storage = getStorage();
  const fileName = `${Date.now()}.png`; // cache-busting filename
  const storageRef = ref(storage, `profilePictures/${userId}/${fileName}`);
  const metadata = {
    contentType: "image/png",
    cacheControl: "public, max-age=31536000, immutable",
  };

  await uploadBytes(storageRef, blob, metadata);

  // 3) Return a URL usable by <Avatar src>
  const downloadURL = await getDownloadURL(storageRef);
  return downloadURL;
};

/**
 * Delete an image from Firebase Storage
 */
export const deleteChallengeImageFromFirebase = async (imageUrl) => {
  const storage = getStorage();
  const imageRef = ref(storage, imageUrl);

  try {
    await deleteObject(imageRef);
    console.log("Image deleted successfully");
  } catch (error) {
    console.error("Error deleting image:", error);
  }
};

/**
 * Accepts a URL (string). Kept the original signature and flow.
 */
export const uploadChallengeImageToFirebase = async (croppedImageUrl, userId) => {
  // Upload challenge hero image (JPEG)
  const response = await fetch(croppedImageUrl);
  const blob = await response.blob();
  const storage = getStorage();
  const storageRef = ref(storage, `challenges/${userId}/${Date.now()}.jpeg`);

  const metadata = {
    contentType: blob.type || "image/jpeg",
    cacheControl: "public, max-age=31536000, immutable",
  };

  await uploadBytes(storageRef, blob, metadata);

  // Get the download URL of the uploaded image
  const downloadURL = await getDownloadURL(storageRef);
  return downloadURL;
};
